module.exports = __webpack_public_path__ + "static/media/new-contact-correct.b705f480.png";